export { default } from './getThemeProps';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/styles/esm/getThemeProps/index.js
// module id = 310
// module chunks = 0